import { useState, useRef, useEffect } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const CustomPopover = ({ title, body, autoClose = 3000 }) => {
  const [show, setShow] = useState(false);
  const triggerRef = useRef(null);

  // Appena show passa a `true`, parte il timer per chiuderlo
  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(() => setShow(false), autoClose);
    return () => clearTimeout(timer);
  }, [show, autoClose]);

  // onToggle ci permette di intercettare apertura/chiusura del popover
  const handleToggle = (nextShow) => {
    setShow(nextShow);
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">{title}</Popover.Header>
      <Popover.Body>{body}</Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      show={show}
      onToggle={handleToggle}
      overlay={popover}
      rootClose  // chiude se clicchi al di fuori
    >
      <span ref={triggerRef} style={{ cursor: "pointer" }}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </span>
    </OverlayTrigger>
  );
};

export default CustomPopover;
